import { socketService } from '@aqx-core/common/socket';
import { IQuoteTopicLiveData } from '@aqx-core/common/socket/subscriptions';
import { safetyCheckForNumberValues } from '@aqx-core/common/utils/number';

import { EQuoteMessageType, IQuoteTopicMessage } from '../topics/quote';

class QuoteTopicSubscription {
  public subscribe = (
    symbol: string,
    subscriptionKey: string,
    updateQuoteData: (updatedData: IQuoteTopicLiveData) => void
  ) => {
    socketService.topics().quote.subscribe({
      symbol: symbol,
      receiver: { subscriptionKey, payload: (payload) => this.quoteTopicReceiver(payload, updateQuoteData) }
    });
  };

  public unsubscribe = (
    symbol: string,
    subscriptionKey: string,
    updateQuoteData: (updatedData: IQuoteTopicLiveData) => void
  ) => {
    socketService.topics().quote.unsubscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => this.quoteTopicReceiver(payload, updateQuoteData)
      }
    });
  };

  private quoteTopicReceiver = (
    payload: IQuoteTopicMessage | undefined,
    updateQuoteData: (updatedData: IQuoteTopicLiveData) => void
  ) => {
    if (payload && payload.M === EQuoteMessageType.LIVE) {
      updateQuoteData(this.massagePayload(payload));
    }
  };

  private massagePayload = (payload: IQuoteTopicMessage) => {
    const updatedData: IQuoteTopicLiveData = {
      symbol: payload.D.S,
      high: safetyCheckForNumberValues(payload.D.H),
      open: safetyCheckForNumberValues(payload.D.O),
      volume: safetyCheckForNumberValues(payload.D.V),
      last: safetyCheckForNumberValues(payload.D.L),
      prevClose: safetyCheckForNumberValues(payload.D.PC),
      noOfTrade: safetyCheckForNumberValues(payload.D.NUM),
      delta: safetyCheckForNumberValues(payload.D.D),
      gamma: safetyCheckForNumberValues(payload.D.G),
      vega: safetyCheckForNumberValues(payload.D.VG),
      theta: safetyCheckForNumberValues(payload.D.TH),
      timestamp: safetyCheckForNumberValues(payload.D.T)
    };

    return updatedData;
  };
}

export const quoteTopicSubscription = new QuoteTopicSubscription();
